import { Component, type ReactElement } from "react";

import { type IPlaybookWizardStepProvidedProps } from "../PlaybookWizardStep.js";
import NCBIAgentConfigureDownloadScreen from "./NCBIAgentConfigureDownloadScreen.js";

type INCBIconfigureOneByOneLooperProps = IPlaybookWizardStepProvidedProps;

interface INCBIconfigureOneByOneLooperState {
  assemblyIndex: number;
  transitionClass: string;
}

class NCBIConfigureOneByOneLooper extends Component<
  INCBIconfigureOneByOneLooperProps,
  INCBIconfigureOneByOneLooperState
> {
  state: INCBIconfigureOneByOneLooperState = {
    assemblyIndex: 0,
    transitionClass: "entering",
  };

  render(): ReactElement {
    return (
      <div
        style={{ height: "100%", width: "100%", position: "relative", display: "flex" }}
        className={`looper-screen ${this.state.transitionClass}`}
      >
        <NCBIAgentConfigureDownloadScreen
          {...this.props}
          assemblyIndex={this.state.assemblyIndex}
          nextAssembly={this.nextAssembly}
          previousAssembly={this.previousAssembly}
        />
      </div>
    );
  }

  nextAssembly = () => {
    this.setState({ transitionClass: "" }, () =>
      setTimeout(() => {
        this.setState({ assemblyIndex: this.state.assemblyIndex + 1, transitionClass: "entering" });
      }, 250),
    );
  };

  previousAssembly = () => {
    this.setState({ transitionClass: "" }, () =>
      setTimeout(() => {
        this.setState({ assemblyIndex: this.state.assemblyIndex - 1, transitionClass: "entering" });
      }, 250),
    );
  };
}

export default NCBIConfigureOneByOneLooper;
